<template>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-col-12">
    <DataTable :value="warehouseGroupLists"
               :paginator="true"
               :rows="10"
               class="p-datatable-responsive p-datatable-gridlines"
               data-key="id"
    >
      <Column header="S.N">
        <template #body="slotProps">
          {{ slotProps.index + 1 }}
        </template>
      </Column>
      <Column header="Name" field="name" filterField="name" filterMatchMode="contains"/>
      <Column header="Action" style="width: 20%;">
        <template #empty>No record found</template>
        <template #body="slotProps">
          <Button class="p-button-raised p-button-success"
                  @click.prevent="editWarehouseGroup(slotProps.data)" icon="pi pi-pencil"/>
          <Button class="p-button-raised p-button-danger"
                  @click.prevent="openDialog(slotProps.data.id)" icon="pi pi-trash"/>
        </template>
      </Column>
    </DataTable>
      </div>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteWarehouseGroup"/>
    </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import Button from 'primevue/button'

export default {
  name: 'warehouseGroupList',
  data() {
    return {
      dialogShow: false,
      id: null
    }
  },
  computed: {
    warehouseGroupLists() {
      return this.$store.state.warehouse.warehouseGroupLists
    }
  },
  mounted() {
    this.warehouseGroupList()
  },
  methods: {
    async warehouseGroupList() {
      await this.$store.dispatch('loadWarehouseGroupList')
    },
    async deleteWarehouseGroup(value) {
      if (value.trim() === '') {
        let message = {
          message: 'Delete reason cannot be empty.',
          messageType: 'error'
        }
        this.$emit('deleteWarehouseGroup', message)
        this.dialogShow = true
        return
      }
      let deleteRe = {
        id: this.id,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteWarehouseGroup', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        let message = {
          message: resp.data.message,
          messageType: 'success'
        }
        this.$emit('deleteWarehouseGroup', message)
      } else {
        let message = {
          message: resp.data.message,
          messageType: 'warn'
        }
        this.$emit('deleteWarehouseGroup', message)
      }
      this.closeDialog()
    },
    editWarehouseGroup(data) {
      this.$emit('edit-warehouseGroup', data)
    },
    cancel(data) {
      this.dialogShow = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.id = id
    },
    closeDialog() {
      this.dialogShow = false
      this.deleteReason = ''
    }
  },
  components: {
    DataTable,
    Column,
    Dialog,
    Button
  }
}
</script>



// WEBPACK FOOTER //
// warehouseGroupList.vue?284c21ee